import { lazy } from "react";

export const Homepage = lazy(() => import("../pages/Homepage/Homepage"));
export const HomepageOld = lazy(
  () => import("../pages/HomepageOld/HomepageOld"),
);
export const Rank = lazy(() => import("../pages/Rank/Rank"));
export const Shop = lazy(() => import("../pages/Shop/Shop"));
export const BundleDetail = lazy(
  () => import("../components/common/BundleDetail/BundleDetail"),
);
